import { Suspense, lazy } from 'react';

import { createFileRoute } from '@tanstack/react-router';

const TimePage = lazy(() =>
  import('@/features/time-tracking/pages/TimePage').then((m) => ({ default: m.TimePage })),
);

function TimePageWrapper() {
  return (
    <Suspense fallback={<div className="p-8 text-center text-quiet">Cargando tiempo...</div>}>
      <TimePage />
    </Suspense>
  );
}

export const Route = createFileRoute('/_app/$wsSlug/time')({
  component: TimePageWrapper,
});
